var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "styled-components";
import { Body1 } from "../Text";
import { colors } from "../Theme/colors";
import { Div } from "../utils";
const Body1White = styled(Body1) `
  color: white;
`;
const AvatarWrapper = styled(Div) `
  border-radius: 100%;
  overflow: hidden;
  color: ${(p) => p.theme.colors.white};
  ${(p) => p.bgColor &&
    css `
      background: ${p.bgColor};
    `}
  ${(p) => p.theme.css.centered};
  svg {
    height: 70%;
    width: 70%;
    color: white;
  }
`;
export const AvatarImg = styled("img") `
  border-radius: 100%;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
export const Avatar = (_a) => {
    var { imgUrl, name, icon, bgColor = colors.black40 } = _a, props = __rest(_a, ["imgUrl", "name", "icon", "bgColor"]);
    return (React.createElement(AvatarWrapper, Object.assign({ dim: 44, bgColor: bgColor }, props),
        icon,
        name && React.createElement(Body1White, null, name && name[0]),
        imgUrl && React.createElement(AvatarImg, { src: imgUrl })));
};
//# sourceMappingURL=index.js.map